/*!
 * Copyright (c) 2022-2023 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

module.exports = {
  CONTEXT_FILENAME_V1: 'data-integrity-v1.jsonld',
  CONTEXT_FILENAME_V2: 'data-integrity-v2.jsonld',
  DATA_INTEGRITY_CONTEXT_V1_URL: 'https://w3id.org/security/data-integrity/v1',
  DATA_INTEGRITY_CONTEXT_V2_URL: 'https://w3id.org/security/data-integrity/v2',
  CONTEXT_URL: 'https://w3id.org/security/data-integrity/v2',
  CBORLD_VALUE_V1: 0x30,
  CBORLD_VALUE: 0x33,
};
